import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ExternalLink, Edit2, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';

const STATUS = {
  draft: { label: 'Borrador', cls: 'bg-slate-100 text-slate-600 border-slate-200' },
  published: { label: 'Publicado', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  archived: { label: 'Archivado', cls: 'bg-amber-50 text-amber-700 border-amber-200' },
};

const eur = (cents, currency='eur') => new Intl.NumberFormat('es-ES',{style:'currency',currency:currency.toUpperCase(),maximumFractionDigits:0}).format((cents||0)/100);

export default function AdminPaidWorkshopList() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get('/admin/paid-workshops')
      .then(r => setItems(r.data || []))
      .catch(() => { toast.error('Error al cargar'); setItems([]); });
  }, []);

  if (!items) return <div className="pt-20 min-h-screen flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-[#c9a227]" /></div>;

  return (
    <div className="pt-20 min-h-screen bg-[#FDFCFA] pb-20">
      <div className="max-w-6xl mx-auto px-6 lg:px-12 py-10">
        <div className="mb-8">
          <p className="text-xs text-[hsl(var(--text-tertiary))] uppercase tracking-wider mb-1">Admin · Cursos</p>
          <h1 className="text-3xl font-heading text-[hsl(var(--text-primary))] flex items-center gap-2">
            <Sparkles className="w-6 h-6 text-[#c9a227]" /> Talleres de pago
          </h1>
          <p className="text-sm text-[hsl(var(--text-secondary))] mt-1">Landings de pago con Stripe + acceso automático post-compra.</p>
        </div>

        {items.length === 0 ? (
          <div className="card-soft text-center py-14">
            <p className="text-sm text-[hsl(var(--text-secondary))]">No hay talleres de pago creados aún.</p>
          </div>
        ) : (
          <div className="card-soft overflow-hidden p-0">
            <table className="w-full text-sm">
              <thead className="bg-[#faf7f2] border-b border-[hsl(var(--border))]">
                <tr className="text-left text-[11px] uppercase tracking-wider text-[hsl(var(--text-tertiary))]">
                  <th className="px-5 py-3">Taller</th>
                  <th className="px-5 py-3">Estado</th>
                  <th className="px-5 py-3">Lote activo</th>
                  <th className="px-5 py-3 text-center">Inscritas</th>
                  <th className="px-5 py-3 text-right">Acciones</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[hsl(var(--border))]">
                {items.map(m => {
                  const st = STATUS[m.status] || STATUS.draft;
                  const at = m.active_tier || {};
                  return (
                    <tr key={m.slug} className="hover:bg-[#fdfbf5]" data-testid={`pw-row-${m.slug}`}>
                      <td className="px-5 py-4">
                        <Link to={`/admin/paid-workshops/${m.slug}`} className="font-medium text-[hsl(var(--text-primary))] hover:text-[#c9a227]">{m.title}</Link>
                        <p className="text-[11px] text-[hsl(var(--text-tertiary))] font-mono mt-0.5">{m.slug}</p>
                      </td>
                      <td className="px-5 py-4"><span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] border ${st.cls}`}>{st.label}</span></td>
                      <td className="px-5 py-4 text-[hsl(var(--text-secondary))]">
                        {at.name ? <><span className="font-medium text-[#8a7428]">{at.name}</span> · {eur(at.amount_cents||0, at.currency||'eur')}</> : '—'}
                      </td>
                      <td className="px-5 py-4 text-center font-medium">{m.enrollments_count || 0}</td>
                      <td className="px-5 py-4">
                        <div className="flex justify-end gap-1">
                          <Link to={`/masterclass/${m.slug}`} target="_blank" className="p-2 rounded-md hover:bg-[#faf6ed] text-[hsl(var(--text-secondary))]"><ExternalLink className="w-4 h-4"/></Link>
                          <Link to={`/admin/paid-workshops/${m.slug}`} className="p-2 rounded-md hover:bg-[#faf6ed] text-[hsl(var(--text-secondary))]"><Edit2 className="w-4 h-4"/></Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
